export default __webpack_public_path__ + "static/loupe-design-system-sheets-token-3d9f25a03164f65c94c4ddc2c89bfc81.png";